import { addCommision } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useAddCommission = () => {
    const queryClient = useQueryClient();
    return useMutation(addCommision, {
        onSuccess: () => {
            toast.success("Added sucesfully");
            queryClient.invalidateQueries('commissions');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}